import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import {useAltenarStore} from "../../../entities/altenar-service";


interface IAltenarParams {
  page: string;
}

export const useAltenar = (props: IAltenarParams) => {
  const { page } = props;
  const altenarStore = useAltenarStore();
  const navigate = useNavigate();
  const altSettings = {
    onSignInButtonClick: () => {
      navigate('/login');
    },
    onRouteChangeDetailed: (data: any) => {
      const url = new URL(window.location.href);
      url.search = new URLSearchParams(data).toString();
      const page = url.search.replace("?page=", '').replace("&widget=WNavigationMenu","");
      // if (page === 'live') navigate('/live-sport');
      // else if (page==='overview') navigate('/sport')
      if (page === 'live') navigate('/live-sport');
      else if (page==='overview') navigate('/sport')
    },

  };
  useEffect(()=>{
    if(altenarStore) altenarStore.addSportbook(altSettings);
  },[altenarStore])

  useEffect(() => {
    if (altenarStore) altenarStore.updateSB({ page });
  }, [page]);
  
};
